import { render, staticRenderFns } from "./IconBoardAgile.vue?vue&type=template&id=7948f3c3&"
import script from "./IconBoardAgile.vue?vue&type=script&lang=js&"
export * from "./IconBoardAgile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports